/**
 * Sends the two events worth having on a product page: which bundle tier a
 * visitor picks, and what actually lands in the cart.
 *
 * Add-to-cart is taken from the network call rather than a button click. The
 * theme dispatches no cart event of its own, and clicks would miss the drawer
 * upsells while counting presses that failed. Watching /cart/add reports what
 * the cart really accepted, from whichever buy box or upsell sent it.
 */
(() => {
  const send = (name, props) => {
    if (!window.posthog || typeof window.posthog.capture !== 'function') return;
    window.posthog.capture(name, props);
  };

  /** Which buy box a node belongs to, so the two can be compared. */
  const whichBox = (node) => {
    const section = node?.closest?.('[id*="shopify-section"]');
    const id = section?.id || '';
    if (id.includes('ms_buybox_2')) return 'second buy box';
    if (id.includes('__main')) return 'main buy box';
    if (node?.closest?.('cart-drawer-component, .cart-drawer__inner')) return 'cart drawer';
    return 'unknown';
  };

  const money = (text) => {
    const n = parseFloat(String(text ?? '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(n) ? n : null;
  };

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches?.('.bundle-tier__input')) return;

    const tier = input.closest('.bundle-tier');
    const selector = input.closest('.bundle-selector');
    const mode = selector?.dataset.mode === 'onetime' ? 'one-time' : 'subscription';

    send('tier_selected', {
      tier: input.value || tier?.querySelector('.bundle-tier__name')?.textContent?.trim(),
      purchase_mode: mode,
      price: money(tier?.dataset.onetimePrice),
      compare_at: money(tier?.dataset.comparePrice),
      location: whichBox(input),
    });
  });

  document.addEventListener('click', (event) => {
    const tab = event.target.closest?.('[data-set-mode]');
    if (!tab) return;
    send('purchase_mode_selected', {
      purchase_mode: tab.dataset.setMode === 'onetime' ? 'one-time' : 'subscription',
      location: whichBox(tab),
    });
  });

  const origin = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const promise = origin.apply(this, args);
    if (!/\/cart\/add/.test(url)) return promise;

    promise
      .then((response) => {
        if (!response.ok) return;
        // Clone: the theme still needs to read this body itself.
        response
          .clone()
          .json()
          .then((data) => {
            const items = data.items || [data];
            items.forEach((item) => {
              if (!item || !item.id) return;
              send('add_to_cart', {
                variant: item.variant_title || item.title,
                quantity: item.quantity,
                price: item.final_line_price != null ? item.final_line_price / 100 : null,
                selling_plan: item.selling_plan_allocation?.selling_plan?.name || null,
                purchase_mode: item.selling_plan_allocation ? 'subscription' : 'one-time',
                location: whichBox(document.activeElement),
              });
            });
          })
          .catch(() => {});
      })
      .catch(() => {});

    return promise;
  };
})();
